import Employee from '@/dataAccess/models/Employee'
import { routerUrls } from '@/router'
import AccessibleClient from '@/dataAccess/models/AccessibleClient'

/**
 * Represents one item in the left hand drawer
 * displaying either client or employee data.
 */
export default class DrawerItem {
  constructor(
    readonly id: number,
    readonly name: string,
    readonly url: string
  ) {}

  static fromClient(client: AccessibleClient): DrawerItem {
    return new DrawerItem(
      client.id,
      client.fullName,
      routerUrls.clientPage + client.id
    )
  }

  static fromEmployee(employee: Employee): DrawerItem {
    return new DrawerItem(
      employee.id,
      employee.username,
      routerUrls.employeePage + employee.id
    )
  }

  /**
   * Designed to use for sorting as parameter for
   * Array.prototype.sort()
   */
  static compare(item1: DrawerItem, item2: DrawerItem): number {
    // ignore upper and lowercase
    const name1 = item1.name.toLowerCase()
    const name2 = item2.name.toLowerCase()
    return name1.localeCompare(name2)
  }
}
